import { Card, CardBody, Col } from "reactstrap";
import { SingleFileuploadTitle } from "../../../constants";
import { FileUploadData } from "../../../data/bonusUi/Dropzone";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import CommonFileUpload from "../../../coreComponents/CommonFileUpload";

const SingleFileupload = () => {
  return (
    <Col lg="6">
      <Card className="single-dropzone">
        <CommonCardHeader title={SingleFileuploadTitle} span={FileUploadData} />
        <CardBody>
          <CommonFileUpload />
        </CardBody>
      </Card>
    </Col>
  );
};
export default SingleFileupload;
